function Plus1(props)
{
    return(
        <svg className={props.class} style={{...props.style}} viewBox="0 0 480 480"><path d="M480 160H320V0H160v160H0v160h160v160h160V320h160V160z"></path></svg>
    )
}

export default Plus1